export default __webpack_public_path__ + "static/media/wordmark.d0b9854f.svg";